export default __webpack_public_path__ + "static/personal1-1536fdeff211c56aff6876771d23aaba.jpg";